var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tbody', [!_vm.rows.records || _vm.rows.records.length < 1 ? _c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.colSpan,
      "align": "center"
    }
  }, [_vm._v("No records found.")])]) : _vm._e(), _vm._l(_vm.rows.records, function (row) {
    return _c('tr', {
      key: row.member_id
    }, [_c('td', [_vm._v(_vm._s(row.member_id))]), _c('td', [_c('div', {
      staticClass: "yellow-section"
    }, [_c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Name: ")]), _c('span', {
      staticClass: "member-name"
    }, [_vm._v(_vm._s(row.member_name))]), row.age_flag === 'member' || row.age_flag === 'both' ? _c('span', {
      staticClass: "pill-red"
    }, [_vm._v("65+")]) : _vm._e()]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Email: ")]), _c('span', [_vm._v(_vm._s(row.email || "-"))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Phone: ")]), _c('span', [_vm._v(_vm._s(row.phone || "-"))])])])]), _c('td', [_vm._v(_vm._s(row.birth_date))]), _c('td', [_vm._v(" " + _vm._s(row.spouse_name || "-") + " "), row.age_flag === 'spouse' || row.age_flag === 'both' ? _c('span', {
      staticClass: "pill-red"
    }, [_vm._v("65+")]) : _vm._e()]), _c('td', [_vm._v(_vm._s(row.spouse_birth_date || "-"))]), _c('td', [_c('div', {
      staticClass: "yellow-section"
    }, [_c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Name: ")]), _c('span', {
      staticClass: "rep-name"
    }, [_vm._v(_vm._s(row.rep_full_name))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Email: ")]), _c('span', [_vm._v(_vm._s(row.rep_email || "-"))])]), _c('div', {
      staticClass: "info-row"
    }, [_c('strong', [_vm._v("Phone: ")]), _c('span', [_vm._v(_vm._s(row.rep_phone || "-"))])])])]), _c('td', [Array.isArray(row.group_name) ? _c('span', _vm._l(row.group_name, function (group, index) {
      return _c('span', {
        key: index,
        staticClass: "groups"
      }, [_vm._v(" " + _vm._s(group) + " ")]);
    }), 0) : _c('span', [_vm._v(" " + _vm._s(row.group_name) + " ")])]), _c('td', _vm._l(row.plan_name, function (plan) {
      return _c('span', {
        key: plan,
        staticClass: "plans"
      }, [_vm._v(" " + _vm._s(plan) + " ")]);
    }), 0)]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }